// extracted by mini-css-extract-plugin
export var container = "_91-0";
export var error = "_91-9";
export var label = "_91-5";
export var light = "_91-6";
export var md = "_91-3";
export var sm = "_91-2";
export var thin = "_91-8";
export var thinBold = "_91-7";
export var vertical = "_91-4";
export var xs = "_91-1";